import { Component, input } from '@angular/core';
import { IconComponent } from '@components/icon/icon.component';

@Component({
  selector: 'app-search-no-results',
  imports: [IconComponent],
  templateUrl: './search-no-results.component.html',
  styleUrl: './search-no-results.component.scss'
})
export class SearchNoResultsComponent {
  public readonly query = input('');
}
